import React, { useState, useMemo } from 'react';
import ReportPage from '../../../Components/crude/ReportPage';
import useReportData from '../../../Components/crude/useReportData';
import {
  REPORT_ENDPOINTS,
  EMPTY_REPORT_FILTERS,
  sulfurLabel,
  yieldLabel,
} from '../../../Components/crude/reportConstants';

// General Report — GET /v1/Report/GetGeneralReports (rhacrude_api).
// Server-driven pagination / sorting / filtering.
//
// `key` on each column is the API's PascalCase sortField. Every displayed
// column is sortable (contract: "Sorting kolom: Semua kolom"); anything outside
// the whitelist returns 400.
const GeneralReportView = () => {
  const [filters, setFilters] = useState(EMPTY_REPORT_FILTERS);

  const {
    items,
    totalRows,
    loading,
    page,
    perPage,
    sortField,
    sortDirection,
    setPage,
    setPerPage,
    handleSort,
  } = useReportData({ endpoint: REPORT_ENDPOINTS.GENERAL.LIST, filters });

  const columns = useMemo(
    () => [
      {
        key: 'CrudeName',
        header: 'Nama Minyak Mentah',
        accessor: row => row.crudeName,
      },
      {
        header: 'Informasi Umum',
        children: [
          {
            key: 'Country',
            header: 'Asal Negara',
            accessor: row => row.country,
          },
          {
            key: 'AssayYear',
            header: 'Tahun Assay',
            accessor: row => row.assayYear,
            align: 'center',
          },
          { key: 'Lab', header: 'Lab', accessor: row => row.lab },
          {
            key: 'Api',
            header: 'API',
            accessor: row => row.api,
            align: 'center',
          },
          {
            key: 'Sulfur',
            header: 'Sulfur (%-WT)',
            accessor: row => row.sulfur,
            align: 'center',
          },
          {
            key: 'SulfurClassification',
            header: 'Klasifikasi Sulfur',
            // Enum arrives as a string like "MediumSour" -> "Medium Sour".
            accessor: row => sulfurLabel(row.sulfurClassification),
          },
          {
            key: 'Tan',
            header: 'Tan (mgKOH/g)',
            accessor: row => row.tan,
            align: 'center',
          },
        ],
      },
      {
        header: 'Yield (%-Vol) & Klasifikasi',
        children: [
          {
            key: 'Gas',
            header: 'Gas',
            accessor: row => row.gas,
            align: 'center',
          },
          {
            key: 'LNaphta',
            header: 'L. Naptha (28-85 °C)',
            accessor: row => row.lNaphta,
            align: 'center',
          },
          {
            key: 'HNaphta',
            header: 'H. Naptha (85-165 °C)',
            accessor: row => row.hNaphta,
            align: 'center',
          },
          {
            key: 'Kerosene',
            header: 'Kerosene (165-250 °C)',
            accessor: row => row.kerosene,
            align: 'center',
          },
          {
            key: 'LGasoil',
            header: 'L. Gasoil (250-300 °C)',
            accessor: row => row.lGasoil,
            align: 'center',
          },
          {
            key: 'HGasoil',
            header: 'H. Gasoil (300-350 °C)',
            accessor: row => row.hGasoil,
            align: 'center',
          },
          {
            key: 'Residu',
            header: 'Residu (> 350 °C)',
            accessor: row => row.residu,
            align: 'center',
          },
          {
            key: 'YieldClassification',
            header: 'Klasifikasi Yield (Update)',
            accessor: row => yieldLabel(row.yieldClassification),
          },
          {
            key: 'YieldClassificationBefore',
            header: 'Klasifikasi Yield (Before)',
            accessor: row => yieldLabel(row.yieldClassificationBefore),
          },
        ],
      },
    ],
    []
  );

  return (
    <ReportPage
      title='General Report'
      cardTitle='General Report'
      documentTitle='General Report'
      columns={columns}
      data={items}
      loading={loading}
      totalRows={totalRows}
      page={page}
      perPage={perPage}
      sortField={sortField}
      sortDirection={sortDirection}
      onChangePage={setPage}
      onChangeRowsPerPage={newPerPage => {
        setPerPage(newPerPage);
        setPage(1);
      }}
      onSort={handleSort}
      filters={filters}
      onFiltersChange={setFilters}
      endpoints={REPORT_ENDPOINTS.GENERAL}
      exportBaseName='general-report'
      emptyText='No general report data found'
    />
  );
};

export default GeneralReportView;
